import useTestId from '@ori/testid-generator';
import { useCallback, useMemo } from 'react';
import type { FC } from 'react';

import { logUserClick } from '../../../utils';
import { BEST_OFFERS_SUB_HEADLINE, BEST_OFFERS_SUB_LINK, BEST_OFFERS_SUBMENU } from './constants';
import { MainCategory, Root, SubItem, SubLink } from './styles';
import type { BestOffersProps } from './types';

export const DesktopBestOffers: FC<BestOffersProps> = ({ content }) => {
  const { getTestId } = useTestId();

  const analyticsData = useCallback(
    (url?: string) => () => {
      logUserClick(url);
    },
    [],
  );

  const itemsList = useMemo(
    () =>
      content?.map((item) => (
        <div key={item.id}>
          <MainCategory
            data-testid={getTestId(BEST_OFFERS_SUB_HEADLINE)}
            variant="subtitle1"
            href={item.url}
            onClick={analyticsData(item.url)}
          >
            {item.title}
          </MainCategory>
          <ul>
            {item.children.map((child) => (
              <SubItem key={child.id}>
                <SubLink
                  data-testid={getTestId(BEST_OFFERS_SUB_LINK)}
                  href={child.url}
                  onClick={analyticsData(child.url)}
                >
                  {child.title}
                </SubLink>
              </SubItem>
            ))}
          </ul>
        </div>
      )),
    [analyticsData, content, getTestId],
  );

  return <Root data-testid={getTestId(BEST_OFFERS_SUBMENU)}>{itemsList}</Root>;
};
